var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49967 10.8333C2.49967 8.79167 3.96634 7.10833 5.89967 6.74167L4.65801 7.99167L5.83301 9.16667L9.16634 5.825L5.83301 2.5L4.65801 3.675L5.97467 4.99167V5.04167C4.55802 5.21211 3.2528 5.89537 2.3055 6.96243C1.3582 8.02948 0.834399 9.40646 0.833008 10.8333C0.833008 14.0583 3.44134 16.6667 6.66634 16.6667H9.16634V15H6.66634C4.36634 15 2.49967 13.1333 2.49967 10.8333ZM10.833 10.8333V16.6667L18.333 16.6667L18.333 10.8333L10.833 10.8333ZM16.6663 15H12.4997V12.5H16.6663V15ZM10.833 3.33333L18.333 3.33333V9.16667L10.833 9.16667L10.833 3.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/ResetIcon.3600ae0133f38b5d98d36767fdde9528.svg";
export { ForwardRef as ReactComponent };